/**
 * prefaces the supplied {@link value} with `an` or `a`, depending on the leading
 * letter
 *
 * @param value the string to test for a leading vowel
 */
export function an(value: string | null | undefined) {
  if (typeof value === 'string' && !value.length) return 'a' as const
  let resolved
  if (value === null) resolved = 'null'
  else if (value === undefined) resolved = 'undefined'
  else resolved = value
  const an = new RegExp(/[aeiou]/i).test(resolved.substring(0, 1))
  return `${an ? 'an' : 'a'} ${value}` as const
}
